// Sales
// API related actions
export const FETCHING_YEARS_WITH_HISTORICAL_VEHICLES_SALES = '@@toyota/FETCHING_YEARS_WITH_HISTORICAL_VEHICLES_SALES';
export const FETCHED_YEARS_WITH_HISTORICAL_VEHICLES_SALES = '@@toyota/FETCHED_YEARS_WITH_HISTORICAL_VEHICLES_SALES';
export const FETCHED_YEARS_WITH_HISTORICAL_VEHICLES_SALES_FAILED =
  '@@toyota/FETCHED_YEARS_WITH_HISTORICAL_VEHICLES_SALES_FAILED';
export const FETCHING_HISTORICAL_VEHICLES_SALES = '@@toyota/FETCHING_HISTORICAL_VEHICLES_SALES';
export const FETCHED_HISTORICAL_VEHICLES_SALES = '@@toyota/FETCHED_HISTORICAL_VEHICLES_SALES';
export const FETCHED_HISTORICAL_VEHICLES_SALES_FAILED = '@@toyota/FETCHED_HISTORICAL_VEHICLES_SALES_FAILED';

// Complementary actions
export const CLEAR_HISTORICAL_VEHICLES_SALES = '@@toyota/CLEAR_HISTORICAL_VEHICLES_SALES';


// Sales Detail
// API related actions
export const FETCHING_HISTORICAL_VEHICLES_SALES_DETAIL = '@@toyota/FETCHING_HISTORICAL_VEHICLES_SALES_DETAIL';
export const FETCHED_HISTORICAL_VEHICLES_SALES_DETAIL = '@@toyota/FETCHED_HISTORICAL_VEHICLES_SALES_DETAIL';
export const FETCHED_HISTORICAL_VEHICLES_SALES_DETAIL_FAILED =
  '@@toyota/FETCHED_HISTORICAL_VEHICLES_SALES_DETAIL_FAILED';
export const DOWNLOADING_HISTORICAL_VEHICLES_SALES_DETAIL = '@@toyota/DOWNLOADING_HISTORICAL_VEHICLES_SALES_DETAIL';
export const DOWNLOADED_HISTORICAL_VEHICLES_SALES_DETAIL = '@@toyota/DOWNLOADED_HISTORICAL_VEHICLES_SALES_DETAIL';
export const DOWNLOADED_HISTORICAL_VEHICLES_SALES_DETAIL_FAILED =
  '@@toyota/DOWNLOADED_HISTORICAL_VEHICLES_SALES_DETAIL_FAILED';
  
// Complementary actions
export const CLEAR_HISTORICAL_VEHICLES_SALES_DETAIL = '@@toyota/CLEAR_HISTORICAL_VEHICLES_SALES_DETAIL';
export const CHANGE_SALES_DETAIL_LIST_PAGE = '@@toyota/CHANGE_SALES_DETAIL_LIST_PAGE';
export const CHANGE_SALES_DETAIL_LIST_PAGE_SIZE = '@@toyota/CHANGE_SALES_DETAIL_LIST_PAGE_SIZE';
export const CLEAR_URL_FILE_FOR_SALES_DETAIL = '@@toyota/CLEAR_URL_FILE_FOR_SALES_DETAIL';


// Stock
// API related actions
export const FETCHING_VEHICLES_STOCK = '@@toyota/FETCHING_VEHICLES_STOCK';
export const FETCHED_VEHICLES_STOCK = '@@toyota/FETCHED_VEHICLES_STOCK';
export const FETCHED_VEHICLES_STOCK_FAILED = '@@toyota/FETCHED_VEHICLES_STOCK_FAILED';

// Complementary actions
export const CLEAR_VEHICLES_STOCK = '@@toyota/CLEAR_VEHICLES_STOCK';
